export const MAX_PAYMENT_LINK_AMOUNT = 500_000;

export type PaymentAmountResult =
  | { ok: true; value: number }
  | { ok: false; error: string };

export function validatePaymentAmount(
  raw: string | number | null | undefined,
  max: number = MAX_PAYMENT_LINK_AMOUNT,
): PaymentAmountResult {
  if (raw === null || raw === undefined || (typeof raw === "string" && raw.trim() === "")) {
    return { ok: false, error: "Please enter an amount." };
  }

  const str = String(raw).trim();
  const value = Number(str);

  if (!Number.isFinite(value) || value <= 0) {
    return { ok: false, error: "Please enter a valid amount greater than 0." };
  }

  const decimals = str.includes(".") ? str.split(".")[1].length : 0;
  if (decimals > 2) {
    return { ok: false, error: "Amount can have at most 2 decimal places (e.g. 499.00)." };
  }

  if (value > max) {
    return {
      ok: false,
      error: `Amount can't exceed ${max.toLocaleString("en-IN")}. Enter a smaller amount.`,
    };
  }

  return { ok: true, value };
}
